export const COLLAPSE = "collapse";
export const EXPAND = "expand";
export const COLLAPSED = "collapsed";
export const EXPANDED = "expanded";
export const CREATE_NEW = "createNew";
export const SCROLL = "scroll";
export const PARENT_VALUE = "parent.value";
export const PARENT = "parent";
export const CHILD = "child";
export const NOT_FOUND = "notFound";
export const CONFIG_DEFAULT_SELECTED_KEY = "config.defaultSelectedKey";
export const REPORT = "report";
export const RESIZE = "resize";
export const FILLER = "filler";
export const DIVIDER = "divider";
export const STATE = "state";
export const STATE_SELECTED = "state-selected";
export const CLICKED = "clicked";
export const HOVERED = "hovered";
